import type { HotelBenefits } from "@/libs/client/goApi/history/historyServiceInterface/getHistoryHotelDetailInterface";
import type { PerkDataInterface } from "@/libs/client/goApi/hotel/hotelServiceInterfaces/getHotelAvailableInterface";

export const mapPerkHistory = (perk: Array<HotelBenefits> = []) => {
  const defaultPerk = { freebies: [], privileges: [] };
  try {
    const splitFreebieAndPrivilege = perk.reduce(
      (prev: PerkDataInterface, current) => {
        if (!current.type) return prev;
        prev[current.type].push(current);
        return prev;
      },
      {
        freebies: [],
        privileges: [],
      },
    );
    return splitFreebieAndPrivilege;
  } catch (e) {
    return defaultPerk;
  }
};
